<template>
  <div class="project item">
    <div class="container custom">
      <div class="project__content single">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="project__content-title" data-aos="fade-up">Timebit Defi</div>
        <div class="project__content-subtitle" data-aos="fade-up">A new generation wallet for a new generation of traders and investors</div>
        <div class="project__content-text" data-aos="fade-up">The new generation of traders and investors is incredibly technologically competent. Therefore, to store digital assets, they always require a reliable, safe wallet which is fastest listed hot coins & tokens.</div>
      </div>
      <div class="project__slide" data-aos="fade" data-aos-delay="500">
      <swiper :options="slideOption" class="project__slide-list">
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebit-defi-01.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebit-defi-02.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebit-defi-03.png" alt="">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination"></div>
      </swiper>
        <p data-aos="fade-up">TimeBird Defi, a new-generation wallet which is non-impacted by operation of any crypto exchange. It can safely store millions of different digital assets including top-50 coins/tokens listing on coinmarketcap.</p>
        <div class="project__slide-card" data-aos="fade" data-aos-delay="500" ref="scrollToMe">
          <div class="card__title">Download App Timebit Defi</div>
          <div class="card__list">
            <div class="card__list-item">
              <a href="https://play.google.com/store/apps/details?id=com.timebitex.wallet&hl=vi&gl=US" target="_blank" class="item__link">
                <img src="/assets/images/project/google-play.png" alt="google-play">
              </a>
              <a href="https://apps.apple.com/vn/app/timebit-wallet/id1555392991?l=vi" target="_blank" class="item__link">
                <img src="/assets/images/project/app-store.png" alt="app-store">
              </a>
            </div>
            <div class="card__list-item">
              <div class="item__qr">
                <img src="/assets/images/project/timebit-defi-qr.png" alt="qr">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project__feature">
        <div class="project__feature-title" data-aos="fade-up">5 why to use Timebit Defi</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title" v-if="item.title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/feature-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="project__guide">
      <div class="container custom">
        <div class="project__guide-title" data-aos="fade-up">How to use Timebit Defi</div>
        <div class="project__guide-step" data-aos="fade" data-aos-delay="500">
          <el-steps :active="active">
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
          <div class="step__progress">
            <div class="step__progress-item download" :class="{ active: active === 0 }">
              <img src="/assets/images/project/icon-download.svg" alt="icon">
            </div>
            <div class="step__progress-item wallet" :class="{ active: active === 1 }">
              <img src="/assets/images/project/icon-wallet.svg" alt="icon">
            </div>
            <div class="step__progress-item setting" :class="{ active: active === 2 }">
              <img src="/assets/images/project/icon-setting.svg" alt="icon">
            </div>
          </div>
          <template v-if="active === 0">
            <div class="step__item">
              <div class="step__item-title">Step 1</div>
              <div class="step__item-content">Download <a href="javascript:;" @click.prevent="scrollToElement" class="link">Timebit Defi</a> on CH Play/ App Store</div>
            </div>
          </template>
          <template v-if="active === 1">
            <div class="step__item">
              <div class="step__item-title">Step 2</div>
              <div class="step__item-content">Import wallet or create new wallet</div>
            </div>
          </template>
          <template v-if="active === 2">
            <div class="step__item">
              <div class="step__item-title">Step 3</div>
              <div class="step__item-content">Set new password and experiment wallet</div>
            </div>
          </template>
        </div>
        <div class="project__guide-button" data-aos="fade">
          <el-button @click="prev" class="button__prev" :class="{ active: active > 0 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
          <el-button @click="next" class="button__next" :class="{ active: active < 2 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      listFeature: [
        { title: '', listFeatureItem: [
          { title: 'Store millions of digital assets (coin, token, NFT, etc)' },
          { title: 'Rapid list new pairs of coin/token' },
          { title: 'Verify by pass code or biometric passord' },
          { title: 'Guarantee strong security and anonymity' },
          { title: 'Easily restore wallet on other device' },
        ]},
      ],
      slideOption: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
          scale: 0.8
        },
        breakpoints: {
          480: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  methods: {
    next() {
      if (this.active++ > 1) this.active = 2;
    },
    prev() {
      if (this.active-- < 1) this.active = 0;
    },
    scrollToElement() {
      const el = this.$refs.scrollToMe
      if (el) {
        el.scrollIntoView({behavior: 'smooth'})
      }
    },
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>